import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Divider } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import LoadStatusPill from "../../../Pills/LoadStatusPill/LoadStatusPill";

export default function QuickActionsHeader({ load, brokerageStatus, originLocation, destinationLocation }) {

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
        <Typography variant="h2" color="black_opacity.100">
          {load?.id}
        </Typography>
        <Typography variant="h4" color="black_opacity.80" sx={{ marginLeft: "20px" }}>
          {originLocation}
        </Typography>
        <ArrowForwardIcon sx={{ marginLeft: "20px", color: "black_opacity.80", fontSize: "20px" }} />
        <Typography variant="h4" color="black_opacity.80" sx={{ marginLeft: "20px" }}>
          {destinationLocation}
        </Typography>
        <Box sx={{ marginLeft: "20px" }}>
          <LoadStatusPill value={brokerageStatus} darkTheme />
        </Box>
      </Box>
      <Divider />
    </Box>
  );
}

QuickActionsHeader.propTypes = {
  load: PropTypes.object.isRequired,
  brokerageStatus: PropTypes.string,
  originLocation: PropTypes.string,
  destinationLocation: PropTypes.string
};